import {
  Box,
  Collapse,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import { Link } from "react-router-dom";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";

export const decodeTimeLine = (timeline: any) => {
  if (timeline === "On going") {
    return "On going";
  } else {
    return parseInt(timeline.split(" ")[0]);
  }
};

export const DaysLeft = (props: any) => {
  props.action["daysLeft"] =
    typeof decodeTimeLine(props.action.timeLine) === "number"
      ? moment(props.action["startDate"])
          .add(decodeTimeLine(props.action.timeLine), "days")
          .diff(moment(), "days")
      : 9999;

  const displayDaysLeft =
    props["action"]["daysLeft"] !== 9999
      ? (props["action"]["daysLeft"] >= 0
          ? props["action"]["daysLeft"]
          : Math.abs(props["action"]["daysLeft"])) +
        (props["action"]["daysLeft"] > 1
          ? " days left"
          : props["action"]["daysLeft"] === 1
          ? " day left"
          : " days late")
      : "On going";

  return (
    <Typography sx={{ textAlign: "center" }}>{displayDaysLeft} </Typography>
  );
};

const TaskCard = (props: any) => {
  const firm = props.firm;
  const [open, setOpen] = React.useState(false);
  return props.action ? (
    <Table sx={{ backgroundColor: "white" }}>
      <TableBody>
        <TableRow onClick={() => setOpen(!open)} sx={{ cursor: "pointer" }}>
          <TableCell sx={{ padding: "6px", width: "50px" }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell sx={{ padding: "0" }}>
            <Stack>
              <Box sx={{ color: "#b3197a", fontSize: "16px" }}>
                {firm ? firm["Company Name"] : ""}
              </Box>
              <Box sx={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                {props.action["businessObjective"]}{" "}
              </Box>
              <Box sx={{ fontWeight: "bold" }}>
                {firm ? firm["Contact"] : ""}
              </Box>
            </Stack>
          </TableCell>
          <TableCell sx={{ width: "150px", paddingLeft: 0 }}>
            <Stack direction={"row"}>
              <AccessAlarmIcon
                sx={{ fontSize: "24px", margin: "auto" }}
                color={
                  props.action.daysLeft < 0
                    ? "error"
                    : props.action.daysLeft < 7
                    ? "warning"
                    : "success"
                }
              ></AccessAlarmIcon>
              <DaysLeft action={props.action}></DaysLeft>
            </Stack>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Link to={`/case?id=${props.case_id}`}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ textDecoration: "underline", color: "#9E1F63FF" }}
                  >
                    {firm ? firm["Company Name"] : ""}
                  </Typography>
                </Link>

                <Typography variant="subtitle2">
                  {props.action["note"]}
                </Typography>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  ) : (
    <></>
  );
};

export default TaskCard;
